export interface IBaseCompany {
  id: number;
  name: string;
  role: string;
  parentRole: string;
  features: number[];
  subdomain?: string;
  website?: string;
}

export interface ICompany extends IBaseCompany {
  parentCompanyId: number | null;
  roleDisplay: string;
  parentName: string;
  isActive: boolean;
  isDemo: boolean;
  businessTypes: number[];
  dbcId: string | null;
}

export class Company implements ICompany {
  id = 0;
  parentCompanyId: number | null = null;
  role = "";
  roleDisplay = "";
  parentName = "";
  parentRole = "";
  name = "";
  isActive = false;
  isDemo = false;
  businessTypes: number[] = [];
  features: number[] = [];
  dbcId = null;

  private constructor(company: ICompany | null) {
    if (company) {
      this.id = company.id;
      this.parentCompanyId = company.parentCompanyId;
      this.role = company.role;
      this.roleDisplay = company.roleDisplay;
      this.parentName = company.parentName;
      this.parentRole = company.parentRole;
      this.name = company.name;
      this.isActive = company.isActive;
      this.isDemo = company.isDemo;
      this.businessTypes = company.businessTypes;
      this.features = company.features;
      this.dbcId = company.dbcId;
    }
  }

  static get EMPTY(): Company {
    return Company.create(null);
  }

  static create(obj: ICompany | null): Company {
    return new Company(obj);
  }
}
